import { styled, Table, lighten } from "@mui/material";

export const StyledTable = styled(Table)(({ theme }) => ({
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
      borderBottom: "none",
      "&:first-of-type": {
        borderRadius: "8px 0px 0px 8px",
      },
      "&:last-of-type": {
        borderRadius: "0px 8px 8px 0px",
      },
    },
  },
  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      padding: "6px 20px",
      "&:first-of-type": {
        borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.8)}`,
      },
      "&:last-of-type": {
        "& .MuiTypography-root": {
          fontSize: "12px",
        },
      },
      "& .MuiButtonBase-root.MuiRadio-root": {
        padding: "0px 9px",
      },
    },
  },
}));
